import { FroMessageMediums } from 'modules/intelligentInsights/frequencyOptimization/types';
import { colors } from 'ui/theme';
import { MessageMedium } from 'constants/messageMediums';

export const MESSAGE_MEDIUM_COLORS: Record<FroMessageMediums, string> = {
  [MessageMedium.Email]: colors.purple100,
  [MessageMedium.Push]: colors.cyan80,
  [MessageMedium.SMS]: colors.green90,
};

export const FREQUENCY_PERIOD = {
  WEEKLY: 7,
  MONTHLY: 30,
};
